export const CHATBOT_HASH = '#rp-customer-widget-home';
